import React from 'react';
import { Trans as OriginalTrans } from 'react-i18next/TransWithoutContext';

export interface CustomTransProps {
  i18nKey: string;
  namespace?: string;
}
export const CustomTrans: React.FC<CustomTransProps> = ({
  i18nKey,
  namespace,
}) => {
  // Modify the i18n key before passing it to the OriginalTrans component
  const modifiedKey: string = `${namespace ? `${namespace}.` : ''}${i18nKey}`;

  // @ts-ignore
  return <OriginalTrans i18nKey={modifiedKey} />;
};
